<div class="modal-header">
  <div class="col-sm-4">
    <h5 *ngIf="isEdit && !task?.draft" class="modal-title" i18n>Edit Task</h5>
    <h5 *ngIf="!isEdit" class="modal-title" i18n>Add Task</h5>
    <h5 *ngIf="task?.draft" class="modal-title" i18n>Approve Task</h5>
  </div>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="modal-body p-0">
  <ul class="nav top-navbar border-bottom mb-3">
    <li [class.active]="activeTab === tabs.Details">
      <a (click)="activeTab = tabs.Details"> <ng-container i18n>Details</ng-container> </a>
    </li>
    <li [class.active]="activeTab === tabs.Checklist">
      <a (click)="activeTab = tabs.Checklist"> <ng-container i18n>Checklist</ng-container> </a>
    </li>
    <li [class.active]="activeTab === tabs.Recurring">
      <a (click)="activeTab = tabs.Recurring"> <ng-container i18n>Recurring</ng-container> </a>
    </li>
    <ng-container *ngIf="isEdit && !task?.draft">
      <li [class.active]="activeTab === tabs.InquiryDetails" *ngIf="form.get('inquiry_id').value">
        <a (click)="activeTab = tabs.InquiryDetails"> <ng-container i18n>Inquiry Details</ng-container> </a>
      </li>
      <li [class.active]="activeTab === tabs.Attributes">
        <a (click)="activeTab = tabs.Attributes"> <ng-container i18n>Custom Attributes</ng-container> </a>
      </li>
      <li [class.active]="activeTab === tabs.VendorImages" *ngIf="vendorImages.length">
        <a (click)="activeTab = tabs.VendorImages"> <ng-container i18n>Vendor Images</ng-container> </a>
      </li>
      <li [class.active]="activeTab === tabs.Conversations">
        <a (click)="activeTab = tabs.Conversations"> <ng-container i18n>Comments</ng-container> </a>
      </li>
      <li [class.active]="activeTab === tabs.History">
        <a (click)="activeTab = tabs.History"> <ng-container i18n>Logs</ng-container> </a>
      </li>
    </ng-container>
  </ul>

  <ng-container [ngSwitch]="activeTab">
    <ng-template *ngSwitchCase="tabs.Details" [ngTemplateOutlet]="taskDetails"></ng-template>
    <ng-template *ngSwitchCase="tabs.Recurring" [ngTemplateOutlet]="recurringFormTpl"></ng-template>
    <ng-template *ngSwitchCase="tabs.Checklist" [ngTemplateOutlet]="checklistFormTpl"></ng-template>
    <app-task-conversations
      *ngSwitchCase="tabs.Conversations"
      [taskId]="data?.taskId"
      class="p-3"
    ></app-task-conversations>
    <app-task-inquiry-details
      *ngSwitchCase="tabs.InquiryDetails"
      [inquiryId]="task?.inquiry_id"
      class="p-3"
    ></app-task-inquiry-details>
    <app-task-history *ngSwitchCase="tabs.History" [taskId]="data?.taskId" class="p-3"></app-task-history>
    <div class="bg-white p-3 rounded-bottom" *ngSwitchCase="tabs.Attributes">
      <app-entity-attributes
        #attrs
        entityType="task"
        [entityId]="data?.taskId"
        [showActions]="false"
      ></app-entity-attributes>
    </div>
    <app-task-vendor-images
      *ngSwitchCase="tabs.VendorImages"
      [vendorImages]="vendorImages"
      class="px-3 pb-3"
    ></app-task-vendor-images>
  </ng-container>
</div>
<div class="text-muted text-sm mt-1 mx-3" *ngIf="data?.taskId">
  <ng-container i18n>Task ID</ng-container>: {{ data?.taskId }}
  <app-copy-icon [content]="data?.taskId"></app-copy-icon>
</div>
<div class="modal-footer">
  <button
    class="btn btn-secondary-danger"
    (click)="onDelete()"
    *ngIf="isEdit && activeTab === tabs.Details && !task?.draft"
  >
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
  </button>

  <div class="flex-fill"></div>
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <ng-container *ngIf="!task?.draft">
    <ng-container *ngIf="activeTab === tabs.Attributes && attrs">
      <button
        (click)="attrs.onConfig()"
        [disabled]="1 | isReadonlyRole"
        type="button"
        class="btn btn-secondary-primary"
      >
        <span class="cs-icon cs-icon-cog"></span>
        <ng-container i18n>Attributes Configuration</ng-container>
      </button>
      <button
        (click)="onSaveAttrs()"
        [disabled]="(1 | isReadonlyRole) || attrs.isSaving"
        type="button"
        class="btn btn-secondary-info"
      >
        <i class="cs-icon cs-icon-save" *ngIf="!attrs.isSaving"></i>
        <i class="far fa-spin fa-spinner" *ngIf="attrs.isSaving"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </ng-container>

    <button
      *ngIf="activeTab == tabs.Details || activeTab == tabs.Checklist || activeTab == tabs.Recurring"
      (click)="onSave(form)"
      type="button"
      [disabled]="(1 | isReadonlyRole) || (isUpdatingTasks$ | async)"
      class="btn btn-secondary-info"
    >
      <span class="cs-icon cs-icon-save"></span>
      <ng-container i18n>Save</ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="task?.draft">
    <button
      (click)="onReject()"
      type="button"
      [disabled]="(1 | isReadonlyRole) || (isUpdatingTasks$ | async)"
      class="btn btn-secondary-danger"
    >
      <span class="cs-icon cs-icon-times"></span>
      <ng-container i18n>Reject</ng-container>
    </button>
    <button
      (click)="onApprove(form)"
      type="button"
      [disabled]="(1 | isReadonlyRole) || (isUpdatingTasks$ | async)"
      class="btn btn-secondary-info"
    >
      <span class="cs-icon cs-icon-check"></span>
      <ng-container i18n>Approve</ng-container>
    </button>
  </ng-container>
</div>

<ng-template #taskDetails>
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="p-3">
      <div class="row">
        <div class="col-md-6 d-flex gap-3">
          <mat-form-field2 class="mat-block">
            <mat-label i18n>Task Name</mat-label>
            <input
              type="text"
              i18n-placeholder
              placeholder="Some task name will go here"
              matInput
              formControlName="name"
              required
            />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('minlength')">
              <ng-container i18n>Minimum length is</ng-container>&nbsp;
              <strong>{{ form.get('name').errors?.minlength.requiredLength }}</strong>
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('maxlength')">
              <ng-container i18n>Maximum length is</ng-container>&nbsp;
              <strong>{{ form.get('name').errors?.maxlength.requiredLength }}</strong>
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('allNumbers')">
              <ng-container i18n>Name cannot be numbers alone.</ng-container>
            </mat-error>
          </mat-form-field2>
          <div class="d-flex align-items-center gap-3" *ngIf="isEdit">
            <app-task-status [task]="task" class="text-sm"></app-task-status>

            <app-task-star-btn class="btn btn-outline-light btn-sm" [task]="task"></app-task-star-btn>
          </div>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              i18n-placeholder
              placeholder="Select Task List"
              matInput
              formControlName="list"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let list of filteredLists | async" [value]="list">
                {{ list }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="form.get('list').touched && form.get('list').hasError('required')">
              <ng-container i18n>Task list is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <app-mat-date-input
              formControlName="start"
              i18n-placeholder
              placeholder="Start Date & Time"
              [showTime]="true"
              [min]="minDateDefault"
              [max]="form.get('due').value"
              required
            ></app-mat-date-input>

            <span matPrefix><i class="fal fa-calendar"></i> </span>
            <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')">
              <ng-container i18n>Start Date & Time is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('start').hasError('min')">
              <ng-container i18n>Min value is</ng-container>&nbsp;
              <strong>{{ form.get('start').getError('min').min | epoch : 'datetime' }}</strong>
            </mat-error>
            <mat-error *ngIf="form.get('start').hasError('max')">
              <ng-container i18n>Max value is</ng-container>&nbsp;
              <strong>{{ form.get('start').getError('max').max | epoch : 'datetime' }}</strong>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <app-mat-date-input
              formControlName="due"
              i18n-placeholder
              placeholder="Due Date & Time"
              [showTime]="true"
              [min]="form.get('start').value || minDateDefault"
              required
            ></app-mat-date-input>

            <span matPrefix><i class="fal fa-calendar"></i> </span>
            <mat-error *ngIf="form.get('due').touched && form.get('due').hasError('required')">
              <ng-container i18n>Due Date & Time is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('due').hasError('min')">
              <ng-container i18n>Min value is</ng-container>&nbsp;
              <strong>{{ form.get('due').getError('min').min | epoch : 'datetime' }}</strong>
            </mat-error>
            <mat-error *ngIf="form.get('due').hasError('max')">
              <ng-container i18n>Max value is</ng-container>&nbsp;
              <strong>{{ form.get('due').getError('max').max | epoch : 'datetime' }}</strong>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-timezone-select [ctrl]="form.get('timezone')"></app-timezone-select>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="status" i18n-placeholder placeholder="Status" required>
              <mat-option *ngFor="let status of statuses" [value]="status.value">
                {{ status.label }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-task-assignee-select [ctrl]="form.get('user_ids')"></app-task-assignee-select>
        </div>
        <div class="col-md-6">
          <app-rental-select
            [ctrl]="form.get('rental_id')"
            [multiple]="false"
            placeholder="Select rental"
            i18n-placeholder
            (selectedItemsChange)="form.get('inquiry_id').reset()"
          >
          </app-rental-select>
        </div>
        <div class="col-md-6">
          <app-booking-select
            [ctrl]="form.get('inquiry_id')"
            [rentalId]="form.get('rental_id').value"
            (selected)="onSelectInquiry($event)"
          ></app-booking-select>
        </div>
        <div class="col-md-6">
          <app-select-search
            [items]="incidents$ | async"
            [ctrl]="form.get('incident_id')"
            [inline]="false"
            [multiple]="false"
            bindLabel="title"
            bindValue="pkey"
            placeholder="Select Incident"
            i18n-placeholder
          >
          </app-select-search>
        </div>
        <div class="col-md-6">
          <app-entity-form-tags
            type="task"
            [id]="data?.taskId"
            [ctrl]="form.get('tags')"
            label="Tags"
          ></app-entity-form-tags>
        </div>
        <div class="col-md-6 mb-3">
          <label><ng-container i18n>Color</ng-container> <sup class="text-danger">*</sup></label>
          <app-color-boxes [ctrl]="form.get('color')" [colors]="colors" [boxSize]="20"></app-color-boxes>
        </div>
        <div class="col-md-12 position-relative">
          <mat-form-field2 class="mat-block" cdkOverlayOrigin #aiSuggestionsTrigger="cdkOverlayOrigin">
            <mat-label>Task Notes</mat-label>
            <textarea
              matInput
              #notes
              rows="3"
              cdkTextareaAutosize
              [cdkAutosizeMaxRows]="5"
              formControlName="notes"
              i18n-placeholder
              placeholder="Some Task details & description of the task will come here along with supporting files & any information will go here"
            ></textarea>
          </mat-form-field2>
          <app-ai-suggestions-icon
            *ngIf="isEdit"
            [entityId]="data?.taskId"
            type="task_description"
            [length]="250"
            [attachTo]="aiSuggestionsTrigger"
            [width]="aiSuggestionsTrigger.elementRef?.nativeElement.clientWidth"
            (apply)="form.get('notes').setValue($event)"
            tooltipText="Generate suggestions for the task description"
            i18n-tooltipText
            class="position-absolute"
            style="bottom: 2rem; right: 2rem"
          ></app-ai-suggestions-icon>
        </div>
      </div>
      <app-upload-box
        [options]="uploadBoxOptions"
        [showFileList]="false"
        *ngIf="!userFiles.length && !(1 | isReadonlyRole)"
        (complete)="onUploadComplete($event)"
      ></app-upload-box>
      <div *ngFor="let item of userFiles; let i = index" class="d-flex align-items-center gap-3">
        <div class="text-primary text-xxl">
          <i class="" [ngClass]="item.name | fileIcon"></i>
        </div>
        <div class="mr-4">{{ item.name }}</div>
        <div class="flex-fill text-light text-right text-sm">
          {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'hh:mm A' }} • {{ item.user }} •
          {{ item.size | fileSize }}
        </div>
        <div>
          <a href="javascript:;" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)"
            ><i class="cs-icon cs-icon-download"></i>
          </a>
          <a
            href="javascript:;"
            class="btn btn-light-danger btn-sm"
            (click)="onDeleteAttachment(item)"
            *ngIf="!(1 | isReadonlyRole)"
            ><i class="cs-icon cs-icon-trash"></i>
          </a>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #recurringFormTpl>
  <app-recurring-form
    [form]="recurringForm"
    [repeatableCtrl]="form.get('repeat')"
    class="d-block p-3"
  ></app-recurring-form>
</ng-template>

<ng-template #checklistFormTpl>
  <app-task-checklist [form]="checklistForm" class="d-block"></app-task-checklist>
</ng-template>
